import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {NgxTranslationOptions} from '@ngx-translations/translations.interfaces';
import {NgxDatePipe, NgxTranslationsPipe} from '@ngx-translations/translations.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [NgxTranslationsPipe, NgxDatePipe],
    exports: [NgxTranslationsPipe, NgxDatePipe]
})
export class NgxTranslationsModule {

    static forRoot(config: NgxTranslationOptions = {production: false, dictionary: []}) {
        return {
            ngModule: NgxTranslationsModule,
            providers: [
                {provide: NgxTranslationOptions, useValue: config}
            ]
        };
    }

}
